import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BatchPayment } from '@wsphere/warranties/domain';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class PaymentHistoryService {
  constructor(private http: HttpClient) {}

  /** The warranties inside one batch. Unpaginated — a batch holds at most MAX_BATCH_SIZE rows. */
  listWarranties(batchPaymentId: string) {
    return firstValueFrom(
      this.http.get<BatchPayment.HistoryWarranty[]>(`/api/batch-payments/${batchPaymentId}/warranties`)
    );
  }
}
